import { useTranslation } from 'react-i18next';
import { IntervalType } from '@Utils/enums';
import {
  Stack,
  Flex,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { Info } from '@Components/Common/Info';

const Section = ({ type }: { type: IntervalType }) => {
  const { t } = useTranslation();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });

  return (
    <>
      <Text color={colorStyle.color.secondary}>
        {t('reportCommon.period.' + type)}:
      </Text>
      <Flex pl="4px">
        <li />
        <Text>{t('reportCommon.period.tip.' + type)}</Text>
      </Flex>
    </>
  );
};

export const Tip = () => {
  return (
    <Info
      placement="top-end"
      content={
        <Stack width="336px" gap="8px">
          <Section type={IntervalType.Hour} />
          <Section type={IntervalType.Day} />
          <Section type={IntervalType.Month} />
        </Stack>
      }
    />
  );
};
